// apps/share-web/src/song-screen/mix-presets.ts
//
// Пресеты микса — обычные комбинации mute/solo, поэтому движок (player.ts) для
// них не меняется. Чистые функции: вход не мутируется.

export interface TrackMix { gain: number; muted: boolean; soloed: boolean; }
export type MixMap = Readonly<Record<string, TrackMix>>;

function mapMix(mix: MixMap, fn: (id: string, m: TrackMix) => TrackMix): Record<string, TrackMix> {
  const out: Record<string, TrackMix> = {};
  for (const id of Object.keys(mix)) out[id] = fn(id, mix[id]);
  return out;
}

/** Слышна только эта дорожка: её соло и снятый мьют; чужие соло сняты; гейны не трогаем. */
export function onlyTrack(mix: MixMap, id: string): Record<string, TrackMix> {
  return mapMix(mix, (k, m) => (k === id ? { ...m, soloed: true, muted: false } : { ...m, soloed: false }));
}

/** Всё, кроме этой дорожки: соло сняты, она заглушена. */
export function withoutTrack(mix: MixMap, id: string): Record<string, TrackMix> {
  return mapMix(mix, (k, m) => (k === id ? { ...m, soloed: false, muted: true } : { ...m, soloed: false }));
}

/** Снять «только / без»: все соло сняты; мьют снимается только у `unmuteId`. */
export function clearFocus(mix: MixMap, unmuteId: string | null): Record<string, TrackMix> {
  return mapMix(mix, (k, m) => ({ ...m, soloed: false, muted: k === unmuteId ? false : m.muted }));
}

/** Весь микс в 0 dB, без мьютов и соло. Master — не здесь. */
export function resetMix(mix: MixMap): Record<string, TrackMix> {
  return mapMix(mix, (_k, m) => ({ ...m, gain: 1, muted: false, soloed: false }));
}

/**
 * «Моя партия» хранится ИМЕНЕМ дорожки, а не id: id у песен разные, а басист
 * остаётся басистом во всех песнях. Совпадение — без регистра и крайних пробелов.
 */
export function findTrackByName(tracks: ReadonlyArray<{ id: string; name: string }>, name: string | null): string | null {
  if (!name) return null;
  const n = name.trim().toLowerCase();
  if (!n) return null;   // «   » — не имя; не должно находить дорожку с пустым названием
  const hit = tracks.find((t) => t.name.trim().toLowerCase() === n);
  return hit ? hit.id : null;
}
